import React from "react";
import { ReactComponent as DesktopIcon } from "../../assets/icons/desktop.svg";

const DesktopOnlyMessage = () => {
  return (
    <div className="dekstop-only-container">
      <div className="desktop-icon-container">
        <DesktopIcon />
      </div>
      <div className="desktop-text-container">
        <div className="desktop-text-content">
          Desktop only. Visit us on a desktop for best experience. Thank you!
        </div>
      </div>
    </div>
  );
};

export default DesktopOnlyMessage;
